var _style, _path, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentFallbackImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 120
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".assessment-fallback-img_svg__st1,.assessment-fallback-img_svg__st4{fill:none;stroke:#72759b;stroke-width:1.059}.assessment-fallback-img_svg__st4{stroke:#fff;stroke-width:4;stroke-linecap:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#011e41",
    d: "M-.4-.1h301v120.5H-.4z",
    id: "assessment-fallback-img_svg__Layer_2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assessment-fallback-img_svg__Rules"
  }, /*#__PURE__*/React.createElement("path", {
    className: "assessment-fallback-img_svg__st1",
    d: "M200.6-20.4l27.1 142.9M238.3-27l27.6 154.7M219.5-23.7L247 125.5M-6.6 35.1L294.6-18M-2.6 52.7l308-53.8M-1.8 70.8l304.4-54.1M-1.6 88.8l311.9-54.7M-6.9 107.3l324.1-57.2M103.5-20.8l26.1 144.2M163-13.7l25.1 135.9M143.9-13.4l24.2 136.6M181.8-17l27 143.5M122-26.8l27.1 151.1M84.5-22.5l24 142.3M26.1-18.9l26.3 148.2M69 3l21.1 119.7M46.7-17l24.6 143M9-4.2l24.4 137.4M257.4-30.2l28 156.1M295.1-36.9l21.1 119.7M276.2-33.5l27.7 153.1M14.9 121l307.9-54.7M31.2 135.9l302.5-53.3M32.5 152.4l302.6-53.3M-14.9 1.8l302.1-53.3M-10.1 19.1l302.5-53.3M63.7-28.8l24 142.2M-9 4l24.5 137.4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "assessment-fallback-img_svg__Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c8d12b",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M90.9 103.2l14.4-30.4 30.4.3 17.5-30.7 33.9 4.3 20.5-32.4"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "assessment-fallback-img_svg__SVGID_1_",
    transform: "rotate(-59.899 204.01 20.054)",
    d: "M187.6 4.9h32.8v30.4h-32.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment-fallback-img_svg__SVGID_00000164507030889487437270000001967233457943918994_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#assessment-fallback-img_svg__SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.3 8.9c.2-3.1-1.7-4.2-4.2-2.5l-23.4 16c-2.6 1.8-2.5 4.5.2 6L205.7 40c2.7 1.6 5.1.3 5.3-2.8l2.3-28.3z",
    clipPath: "url(#assessment-fallback-img_svg__SVGID_00000164507030889487437270000001967233457943918994_)",
    fill: "#c8cf41"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "assessment-fallback-img_svg__X_x2F_Y_co-ordinates"
  }, /*#__PURE__*/React.createElement("path", {
    className: "assessment-fallback-img_svg__st4",
    d: "M75.2 110l245.6-43.3M89.7 122.4L67.4-6.6"
  }))));
}
export default SvgAssessmentFallbackImg;